import { combineReducers } from 'redux';

import account, { AccountState } from 'redux/account/reducer';
import ads, { AdsReduxState } from 'redux/ads/reducer';
import auth, { AuthState } from 'redux/auth/reducer';
import blocked, { BlockedState } from 'redux/blocked/reducer';
import comments, { CommentState } from 'redux/comments/reducer';
import counters, { CountersState } from 'redux/counters/reducer';
import geolocation, { GeoLocationState } from 'redux/geolocation/reducer';
import group, { GroupState } from 'redux/group/reducer';
import groups, { GroupsState } from 'redux/groups/reducer';
import guests, { GuestsState } from 'redux/guests/reducer';
import chat, { ChatState } from 'redux/chat/reducer';
import moderation, { ModerationState } from 'redux/moderation/reducer';
import moderators, { ModeratorsState } from 'redux/moderators/reducer';
import notifications, { NotificationsState } from 'redux/notifications/reducer';
import oauth, { OAuthState } from 'redux/oauth/reducer';
import people, { PeopleState } from 'redux/people/reducer';
import photoAlbums, { PhotoAlbumsState } from 'redux/photo-albums/reducer';
import posts, { PostsState } from 'redux/posts/reducer';
import profile, { ProfileState } from 'redux/profile/reducer';
import rateLimit, { RateLimitState } from 'redux/rate-limit/reducer';
import routerBranch, { RouteBranchState } from 'redux/route-branch/reducer';
import tags, { InterestTagState } from 'redux/tags/reducer';
import translations, { TranslationsState } from 'redux/translations/reducer';
import trips, { TripsState } from 'redux/trips/reducer';
import upload, { PhotoUploadState } from 'redux/upload/reducer';
import viewed, { ViewedState } from 'redux/viewed/reducer';

export interface ReduxState {
    account: AccountState;
    ads: AdsReduxState;
    auth: AuthState;
    blocked: BlockedState;
    chat: ChatState;
    comments: CommentState;
    counters: CountersState;
    geolocation: GeoLocationState;
    group: GroupState;
    groups: GroupsState;
    guests: GuestsState;
    moderation: ModerationState;
    moderators: ModeratorsState;
    notifications: NotificationsState;
    oauth: OAuthState;
    people: PeopleState;
    photoAlbums: PhotoAlbumsState;
    posts: PostsState;
    profile: ProfileState;
    rateLimit: RateLimitState;
    routerBranch: RouteBranchState;
    tags: InterestTagState;
    translations: TranslationsState;
    trips: TripsState;
    upload: PhotoUploadState;
    viewed: ViewedState;
}

const rootReducer = combineReducers({
    account,
    ads,
    auth,
    blocked,
    chat,
    comments,
    counters,
    geolocation,
    group,
    groups,
    guests,
    moderation,
    moderators,
    notifications,
    oauth,
    people,
    photoAlbums,
    posts,
    profile,
    rateLimit,
    routerBranch,
    tags,
    translations,
    trips,
    upload,
    viewed,
});

export default rootReducer;
